import { ResetPassword } from '@desquared/wave-components-library';
import React, { useState } from 'react';
import { forgotPassword } from '@/api/register';
import { OTPIDStore } from '@/store/otpid';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import styles from './PasswordReset.module.css';

export default function PasswordReset({ logo, type, user }) {
  const [emailErrorText, setEmailErrorText] = useState('');
  const [email, setEmail] = useState(user ? (user?.email ? user.email : '') : '');

  const t = useTranslations('user_credentials.password_reset');

  const router = useRouter();

  const onEmailChange = e => {
    setEmail(e.currentTarget.value);
    setEmailErrorText('');
  };

  const submit = async () => {
    const { data, error } = await forgotPassword(email);
    if (error) {
      if (error.status === 400) {
        setEmailErrorText(t('wrong_email'));
        return;
      } else if (error.code === 'AUTH0013') {
        setEmailErrorText(t('email_not_found'));
        return;
      }
    } else {
      if (data.status === 'NEED_VERIFICATION') {
        OTPIDStore.update({ requestId: data.otpInfo.requestId, email: email });
        const params = { pageFrom: 'password-reset' };
        router.push(
          {
            pathname: '/otp',
            query: params,
          },
          undefined,
          { shallow: false }
        );
      }
    }
  };

  return (
    <div className={styles.container}>
      <ResetPassword
        onContinueClick={submit}
        onEmailChange={onEmailChange}
        logo={logo}
        logoRedirect={router.locale === router.defaultLocale ? '/' : `/${router.locale}/`}
        titleText={t('title')}
        description={`${t('description')} `}
        companySite={process.env.companySite + ':'}
        continueText={t('continue')}
        emailErrorText={emailErrorText ?? emailErrorText}
        emailLabelText={t('email')}
        emailPlaceHolderText={t('enter_here')}
        emailHelperTextType={emailErrorText ? 'error' : 'helper'}
        emailValue={email}
        supportEmail={process.env.supportEmail}
        assistiveText={t('assistive')}
        classOption={type === 1 || type === 2 ? styles.paddingContainer : styles.noPaddingContainer}
      />
    </div>
  );
}
